<div class="ai-action-dialog" cdkDrag>
  <div class="dialog-title-bar" cdkDragHandle>
    <h2>{{ data.actionDisplayName }}</h2>
    <button mat-icon-button (click)="discard()">
      <mat-icon>close</mat-icon>
    </button>
  </div>
  <mat-dialog-content>
    <div class="section">
      <div class="section-label">{{ 'EDITOR.AI_ACTION_DIALOG.CURRENT_SELECTION' | translate }}:</div>
      <div class="section-content original">{{ data.originalContent }}</div>
    </div>
    <div class="section">
      <div class="section-label">{{ 'EDITOR.AI_ACTION_DIALOG.NEW_CONTENT' | translate }}:</div>
      <div class="section-content">
        @if (generatedText$ | async; as text) {
          <span class="generated-content">{{ text }}</span>
        } @else {
          <span class="generated-placeholder">{{ 'EDITOR.GENERATING' | translate }}</span>
        }
      </div>
    </div>
  </mat-dialog-content>
  <mat-dialog-actions align="end">
    <button mat-button (click)="discard()">{{ 'EDITOR.AI_ACTION_DIALOG.DISCARD' | translate }}</button>
    <button mat-raised-button color="primary" [disabled]="(isComplete$ | async) === false" (click)="accept()">
      {{ 'EDITOR.AI_ACTION_DIALOG.INSERT' | translate }}
    </button>
  </mat-dialog-actions>
</div>
